import { render, staticRenderFns } from "./homehelp2.vue?vue&type=template&id=b68f87fa&scoped=true&lang=html"
import script from "./homehelp2.vue?vue&type=script&lang=js"
export * from "./homehelp2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68f87fa",
  null
  
)

export default component.exports